import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayViewChecksPage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayViewChecksPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayQuickTourViewChecks
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Quick Tour" capture group.
 */
export default function CapturePositivePayQuickTourViewChecks(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    return <TASPositivePayViewChecksPage />;
}